export const SHOW_MENA_BANNER = "SHOW_MENA_BANNER";
export const DISMISS_MENA_BANNER = "DISMISS_MENA_BANNER";

// Empty array means MENA banner is effectively disabled.
export const MENA_COUNTRY_CODES = [];

export const MENA_BANNER_DISMISSED_KEY = "Asos.SiteChrome.Redirection";
